import "./App.css";
import { useState, useEffect } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { Box, Typography } from "@mui/material";
import { FiAlertTriangle } from "react-icons/fi";
import { compareVersions } from "compare-versions";
import Footer from "./components/Footer";
import version from "./api/versionCaldenOil";
import DividirPagoPage from "./pages/DividirPagoPage";
import Conexion from "./api/conexion";
import banderas from "./api/banderas";
import estacion from "./api/estacion";
import limiteAfip from "./api/limiteAfip";
import tarjetas from "./api/tarjetas";
import talonarioQR from "./api/talonarioQR";
import passEmpleado from "./api/empleado";
import puestos from "./api/puestos";
import qrs from "./api/qr";
import configuracionIntegracionesFULL from "./api/configuracionIntegracionesFULL";
import { guardarTalonarios } from "./helpers/guardarTalonariosHelper";
import { setStatusBarColor } from "./helpers/nativeInterface";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PagoConMercadopago from "./pages/PagoConMercadopago";
import TicketCanvas from "./components/GenerateImage";
import Comprobante from "./components/Comprobante";
import FinalizarPago from "./pages/FinalizarPago";
import SignaturePadComponent from "./components/SignaturePadComponent";
import ClientesSearchPage from "./pages/ClientesSearchPage";
import ArticulosSearchPage from "./pages/ArticulosSearchPage";
import DespachosSearchPage from "./pages/DespachosSearchPage";
import FormasDePagoPage from "./pages/FormasDePagoPage";
import CuotasPage from "./pages/CuotasPage";
import ContraPage from "./pages/ContraPage";
import DialogoImprimirFacturaPage from "./pages/DialogoImprimirFacturaPage";
import AltaCliente from "./pages/AltaCliente";
import { PagoQRPage } from "./pages/PagoQRPage";
import CierreTurnoPage from "./pages/CierreTurnoPage";
import ListadoQRPage from "./pages/ListadoQRPage";
import DashboardMini from "./pages/DashboardMini";
import DatosChofer from "./pages/DatosChofer";
import DespachoManualPage from "./pages/DespachoManualPage";
import TransferenciaPage from "./pages/TransferenciaPage";
import ConfiguracionesPage from "./pages/ConfiguracionesPage";
import ConsultarPuntos from "./pages/ConsultarPuntos";
import ObtenerDNIPuntos from "./pages/ObtenerDNIPuntos";
import CanjesPage from "./pages/CanjesPage";
import SaldosCtacte from "./pages/SaldosCtacte";
import AcumulacionPuntoServiclubPage from "./pages/AcumulacionPuntosServiclubPage";
import { TiendaPage } from "./pages/TiendaPage";
import ControlDeStockPage from "./pages/ControlDeStockPage";
import { AutoservicioPage } from "./pages/AutoservicioPage";
import { SeleccionIslaPage } from "./pages/SeleccionIslaPage";
import DialogoEnviarFacturaPage from "./pages/DialogoEnviarFacturaPage";
import { TiendaKioskPage } from "./pages/tiendaKioskPage";
import { DetallesKioskPage } from "./pages/DetallesKioskPage";
import { PagoKioskPage } from "./components/kiosk-components/pago-kiosk/PagoKioskPage";
import { GraciasPorComprarPage } from "./pages/GraciasPorComprarPage";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [versionActual, setVersionActual] = useState("");
  const [showVersionWarning, setShowVersionWarning] = useState(false);
  const [appReady, setAppReady] = useState(false);

  const tiendaPages = ["/tiendaPage", "/tiendakioskpage", "/detalleskioskpage"];
  const isTiendaPage = tiendaPages.includes(location.pathname);

  useEffect(() => {
    const bootstrapApp = async () => {
      const userData = {
        nombre: "AONIKEN",
        password: "AONIKEN",
        nic: Conexion.formatearNIC("EXPO:2025"),
      };

      try {
        const response = await Conexion.validarUsuario(userData);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", response.data.nombre);
        localStorage.setItem("formattedNic", userData.nic);
        localStorage.setItem("nic", "EXPO:2025");

        const limite = await limiteAfip.getLimiteAfip();
        localStorage.setItem("limite", limite);

        await banderas.getBanderas();
        localStorage.setItem("bandera", "point");

        const estacionData = await estacion.getEstacion();
        localStorage.setItem("estacionData", JSON.stringify(estacionData));

        const talonarioQRInfo = await talonarioQR.getIdTalonarioQR();
        localStorage.setItem("idTalonarioQR", talonarioQRInfo.data.idTerminalTarjeta);

        const passEmpleados = await passEmpleado.getEmpleado();
        localStorage.setItem("passEmpleados", JSON.stringify(passEmpleados.data));

        const tarjetasData = await tarjetas.getTarjetas();
        localStorage.setItem("tarjetas", JSON.stringify(tarjetasData));

        const allPuestos = await puestos.getPuestos();
        localStorage.setItem("puestosArray", JSON.stringify(allPuestos));

        if (allPuestos.length > 0) {
          const puestoDefault = allPuestos[window.innerWidth < 700 ? 0 : 4] || allPuestos[0];
          localStorage.setItem("puesto", JSON.stringify(puestoDefault));
          localStorage.setItem("cantidadPlayerosSolicitados", puestoDefault.caja?.cantidadPlayerosSolicitados || 0);
          localStorage.setItem("solicitarAforadores", puestoDefault.caja?.solicitarAforadores || false);
          localStorage.setItem("idCaja", puestoDefault.caja?.idCaja || "");
          localStorage.setItem("perteneceFULL", puestoDefault.talonarios[0]?.perteneceFULL || false);
          localStorage.setItem("combustiblesSoloPorDespachos", puestoDefault.combustiblesSoloPorDespachos);
          localStorage.setItem("nombreCaja", puestoDefault.caja?.descripcion || "");
          guardarTalonarios(puestoDefault);
        }

        localStorage.setItem("prefijoFront", "55");
        localStorage.setItem("isQRSwitchOn", JSON.stringify(true));
        localStorage.setItem("conListadoQR", false);
        localStorage.setItem("useTips", JSON.stringify(false));
        localStorage.setItem("useCashback", JSON.stringify(false));

        const qrsEstacion = await qrs.getQRs();
        const qrsOrdenados = qrsEstacion.sort((a, b) => a.posi - b.posi);
        localStorage.setItem("qrsArray", JSON.stringify(qrsOrdenados));
        if (qrsOrdenados.length > 0) {
          const qrDefault = qrsOrdenados[0];
          localStorage.setItem("idPosicionQR", qrDefault.posi.toString());
          localStorage.setItem("urlPosicionQR", qrDefault.url);
        }

        const habilitarFacturacionArticulosFullPlaya = await configuracionIntegracionesFULL.getConfiguracionIntegracionesFULL();
        localStorage.setItem("habilitarFacturacionArticulosFullPlaya", habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya);
        localStorage.setItem("habilitaTiendaFull", true);

        if (!setStatusBarColor("#FFE600")) {
          console.warn("MyInterface no está disponible");
        }
      } catch (error) {
        console.error("Error inicializando la app:", error);
      } finally {
        setAppReady(true);
      }
    };

    const versionCheck = async () => {
      try {
        const response = await version.getVersionCaldenOil();
        const versionData = response.versionCaldenOil;
        setVersionActual(versionData);

        const versionMinima = process.env.REACT_APP_CALDENOIL_MIN_VERSION;
        if (compareVersions(versionData, versionMinima) < 0) {
          setShowVersionWarning(true);
        }
      } catch (error) {
        console.error("Error al obtener la versión:", error);
      }
    };

    // En /login no se hace el login automático: el usuario ingresa sus datos
    if (window.location.pathname === "/login") {
      setAppReady(true);
    } else {
      bootstrapApp();
    }
    versionCheck();
    if (window.location.pathname === "/") {
      navigate("/home", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <CssBaseline />
      <div className={`App ${isTiendaPage ? "tienda-bg" : ""}`}>
        {!appReady ? null : (
        <Routes>
          <Route element={<Home />} path="/" />
          <Route element={<Home />} path="/home" />
          <Route element={<Login />} path="/login" />
          <Route element={<ContraPage />} path="/contrapage" />
          <Route element={<Dashboard />} path="/dashboard" />
          <Route element={<ClientesSearchPage />} path="/clientessearchpage" />
          <Route element={<ArticulosSearchPage />} path="/articulossearchpage" />
          <Route element={<DespachosSearchPage />} path="/despachossearchpage" />
          <Route element={<FormasDePagoPage />} path="/formasdepagopage" />
          <Route element={<CuotasPage />} path="/cuotaspage" />
          <Route element={<DialogoEnviarFacturaPage />} path="/dialogoimprimirfacturapage" />
          <Route element={<TicketCanvas />} path="/ticket" />
          <Route element={<Comprobante />} path="/comprobante" />
          <Route element={<PagoConMercadopago />} path="/pagoConMercadopago" />
          <Route element={<FinalizarPago />} path="/finalizarPago" />
          <Route element={<SignaturePadComponent />} path="/firma" />
          <Route element={<PagoQRPage />} path="/pagoqrpage" />
          <Route element={<AltaCliente />} path="/altacliente" />
          <Route element={<CierreTurnoPage />} path="/CierreTurnoPage" />
          <Route element={<ListadoQRPage />} path="/listadoqrpage" />
          <Route element={<DashboardMini />} path="/dashboardmini" />
          <Route element={<DatosChofer />} path="/datoschofer" />
          <Route element={<DespachoManualPage />} path="/despachomanualpage" />
          <Route element={<TransferenciaPage />} path="/transferenciapage" />
          <Route element={<ConfiguracionesPage />} path="/configuracionespage" />
          <Route element={<ConsultarPuntos />} path="/consultarPuntos" />
          <Route element={<ObtenerDNIPuntos />} path="/obtenerdnipuntos" />
          <Route element={<CanjesPage />} path="/canjesPage" />
          <Route element={<SaldosCtacte />} path="/saldosCtacte/:idCliente/:nombreCliente" />
          <Route element={<AcumulacionPuntoServiclubPage />} path="/acumulacionpuntosserviclub" />
          <Route element={<TiendaPage />} path="/tiendaPage" />
          <Route element={<ControlDeStockPage />} path="/controldestockpage" />
          <Route element={<AutoservicioPage />} path="/autoservicioPage" />
          <Route element={<SeleccionIslaPage />} path="/autoservicioPage/seleccionIsla" />
          <Route element={<DividirPagoPage />} path="/dividirpagopage" />
          <Route element={<TiendaKioskPage />} path="/tiendakioskpage" />
          <Route element={<DetallesKioskPage />} path="/detalleskioskpage" />
          <Route element={<PagoKioskPage />} path="/pagokioskpage" />
          <Route element={<GraciasPorComprarPage />} path="/graciasporcomprarpage" />
        </Routes>
        )}
      </div>

      <Footer versionActual={versionActual} />

      {showVersionWarning && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              padding: "30px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "92%",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: 3,
            }}
          >
            <FiAlertTriangle style={{ fontSize: "4rem", color: "#d32f2f" }} />
            <Typography variant="h5" sx={{ fontWeight: "bold", mt: 2 }}>
              Versión incompatible
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              Se está utilizando la versión <strong>{versionActual}</strong> de CaldenOil. <br /> Se requiere la versión
              mínima <strong>{process.env.REACT_APP_CALDENOIL_MIN_VERSION}</strong>.
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: "#d32f2f", fontWeight: "bold" }}>
              Actualiza CaldenOil para continuar.
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}

export default App;
